export default __webpack_public_path__ + "static/media/06.954ac0cc.svg";